export default __webpack_public_path__ + "static/media/include_13_male@2x.8f1380ce.jpg";